import { connect } from 'react-redux';
import Map from 'components/map/Map';
import {
  clearSelection,
  hoverFeature,
  mapLoaded,
  selectFeature,
  selectMapConfig,
  selectMapLayers,
  selectMapLoaded,
  unhoverFeature,
} from 'modules/map';
import { selectIsInitialized } from 'modules/geojson';

export default connect(
  state => ({
    isInitialized: selectIsInitialized(state),
    isMapLoaded: selectMapLoaded(state),
    mapConfig: selectMapConfig(state),
    mapLayers: selectMapLayers(state),
  }),
  {
    clearSelection,
    hoverFeature,
    mapLoaded,
    selectFeature,
    unhoverFeature,
  },
)(Map);
